import React from 'react';
import {Platform} from 'react-native';
import {noop} from 'lodash';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useCoachesToCelebrateSection} from './CoachesToCelebrateSection.hook';
interface CoachesToCelebrateSectionProps {
  clientAcquisitionBonus: number;
  clientQuickStartBonus: number;
  onShowReport: () => void;
  rankUp: number;
  onShowInfoPopover: () => void;
  earnedAccelBonusCount: number;
  earnedClientSupportBonusPlusCount: number;
  qualifiedIncentiveTripCount: number;
  showCSBPlus: boolean;
  showIncentiveTrip: boolean;
  showEarnedQSB: boolean;
}
export const CoachesToCelebrateSection: React.FC<
  CoachesToCelebrateSectionProps
> = ({
  clientAcquisitionBonus,
  clientQuickStartBonus,
  onShowReport = noop,
  rankUp,
  onShowInfoPopover = noop,
  earnedAccelBonusCount,
  earnedClientSupportBonusPlusCount,
  qualifiedIncentiveTripCount,
  showCSBPlus = false,
  showIncentiveTrip = false,
  showEarnedQSB = false,
}) => {
  const {listItems, onInfoPress, onItemPress, ts} =
    useCoachesToCelebrateSection({
      clientAcquisitionBonus,
      clientQuickStartBonus,
      onShowReport,
      rankUp,
      onShowInfoPopover,
      earnedAccelBonusCount,
      earnedClientSupportBonusPlusCount,
      showCSBPlus,
      qualifiedIncentiveTripCount,
      showIncentiveTrip,
      showEarnedQSB,
    });
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;

  return (
    <MetricSection
      analyticsTitle="Coaches to Celebrate"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Coaches to Celebrate Section Information',
      )}
      testID={MetricsSection.metricSectionCoachesToCelebrate}
      title={ts('heading', 'Coaches to Celebrate')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default CoachesToCelebrateSection;
